<template>
  <div id="secondaryContentContainer">
    <ul id="localNav">
      <li class="localNavItem">
        <span>
          <a
            href="#"
            class="filter-selected"
            :class="{ selected: selectedClient === 'not-archived' }"
            @click.stop.prevent="changeSelectedClient('not-archived')"
            >Active</a
          >
        </span>
      </li>

      <li class="localNavItem">
        <a
          href="#"
          class="filter-selected"
          :class="{ selected: selectedClient === 'archived' }"
          @click.stop.prevent="changeSelectedClient('archived')"
          >Archived</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showDropDown: false
    };
  },
  props: {
    selectedClient: String,
    changeSelectedClient: Function
  }
};
</script>

<style scoped>
ol,
ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}

#status-1 {
  padding-left: 13px;
  padding-top: 15px;
  float: left;
  width: 100%;
}

#status-1 .res-menu li {
  background-color: #adbfd2;
  float: left;
  padding: 3px;
  position: relative;
}

#status-1 .res-menu a {
  padding: 0px 3px;
  width: 101px;
  float: left;
  line-height: 22px;
  border: 1px solid #ccc;
  font-weight: bold;
  color: #000;
  font-size: 13px;
}

#status-1 .res-menu a .img-res {
  margin-right: 4px;
  top: 3px;
  height: 16px;
  position: relative;
}

#status-1 .res-menu a .img1-res {
  float: right;
  position: relative;
  top: 4px;
  left: 0px;
}

#status-1 .res-menu ul {
  display: block;
  position: absolute;
  width: 100%;
  top: 30px;
  left: 0;
  z-index: 99;
}

ul#localNav {
  float: left;
  width: 100%;
  color: #000;
  margin: 0.25em 0 0 1em;
  list-style-type: none;
  position: relative;
  white-space: nowrap;
  padding: 0;
  z-index: 10;
  padding-bottom: 2px;
}

ul#localNav li {
  display: inline-block;
  min-width: 70px;
  margin-bottom: 5px;
}

#localNav #full-chart {
  padding: 0;
  position: relative;
  float: right;
  margin-right: 40px;
  color: #d26d13;
}

.search {
  margin: 0 auto;
  width: 756px;
}

.search div {
  margin: 11px 1em 10px;
  width: 96%;
  background-color: #fff;
  border: 1px solid #000;
  float: left;
}

.search div input {
  width: 93%;
  border: transparent;
  line-height: 23px;
  outline: none;
  padding-left: 20px;
  color: #444;
}

.search div a {
  float: right;
  margin-right: 10px;
}

.search div a img {
  height: 16px;
  position: relative;
  top: 3.5px;
}
.filter-selected {
  padding: 4px;
  min-width: 70px;
  float: left;
  text-align: center;
  font-size: 13px;
  color: grey;
  border: 1px solid grey;
  margin-right: 10px;
}
.filter-selected.selected {
  background-color: #d26d13;
  color: #fff;
  border-color: transparent;
}
@media (max-width: 768px) {
  .search {
    width: 98%;
  }

  .search div {
    width: 96%;
    margin: 0 auto;
    float: none;
    clear: both;
    margin-bottom: 10px;
    background-color: #fff;
  }

  .search div input {
    padding-left: 10px;
    width: 60%;
  }
}

.zoom-enter-active {
  animation: zoomIn 0.2s ease-in-out;
}

.zoom-leave-active {
  animation: zoomOut 0.2s ease-in-out;
}

@keyframes zoomIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes zoomOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
</style>
